import ImageDetail from './image-detail.component';

export default {
  Root: ImageDetail,
};
